import containerFuild from '../html-snippets/container-fuild';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-card-satellite-rivoneed';
const buttonRivoneedHtml = buttonPrimaryHtml({
  text: "A Gift He'll Actually Use",
  backgroundColor: '#ff0000',
  color: '#ffffff',
  radius: 8,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-show="true" data-attribute="card-title" class="card-title">
      <h2 style="text-align: center">One Light. Every Garage Job Done.</h2>
      <p style="text-align: center">No dark corners. Just powerful light for every task.</p>
    </div>
    <div class="wrap-satellite">
      <div data-use-video="true" data-attribute="main-satellite" class="main">
        <div class="wrap-video">
          <video
            data-attribute="video-satellite"
            autoplay=""
            muted=""
            loop=""
            playsinline=""
            type="video/mp4"
            src="https://cdn.shopify.com/videos/c/o/v/5f974fb20e3b4360b32deed478fcee5b.mp4"
          ></video>
        </div>
        <div class="wrap-img" style="display: none">
          <img data-attribute="img-satellite" src="" alt="" />
        </div>
      </div>
      <div data-attribute="wrap-list-small" class="wrap-list-small">
        <div data-overlay-opacity="0" data-attribute="item-small" class="item-small" style="--overlay-opacity: 0">
          <div data-attribute="text-content" class="text-content">
            <h3>Strong Magnetic Grip</h3>
            <p>Magnets lock on. Both hands free.</p>
          </div>
          <img
            data-attribute="img-small"
            src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bc9012469f4f080ec7d77.webp?w=50&amp;h=50&amp;q=80"
            alt=""
          />
        </div>

        <div data-overlay-opacity="0" data-attribute="item-small" class="item-small" style="--overlay-opacity: 0">
          <div data-attribute="text-content" class="text-content">
            <h3>3000LM Flood Light</h3>
            <p>Bright flood light. No dark corners.</p>
          </div>
          <img
            data-attribute="img-small"
            src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bc907c91453eff7f61c23.jpg?w=50&amp;h=50&amp;q=80"
            alt=""
          />
        </div>

        <div data-overlay-opacity="0" data-attribute="item-small" class="item-small" style="--overlay-opacity: 0">
          <div data-attribute="text-content" class="text-content">
            <h3>5200mAh Large Battery</h3>
            <p>One charge lasts a full workday.</p>
          </div>
          <img
            data-attribute="img-small"
            src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bc90b9da7d8580c6228f0.webp?w=50&amp;h=50&amp;q=80"
            alt=""
          />
        </div>

        <div data-overlay-opacity="0" data-attribute="item-small" class="item-small" style="--overlay-opacity: 0">
          <div data-attribute="text-content" class="text-content">
            <h3>Shockproof &amp; Waterproof</h3>
            <p>IPX4 for rain. IK08 for drops.</p>
          </div>
          <img
            data-attribute="img-small"
            src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2bc9118bae60b44f6d6951.jpg?w=50&amp;h=50&amp;q=80"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
  </div>
</div>

`;
export default containerFuild(html, css, {
  backgroundColor: '#1a1a1a',
  textColor: '#ffffff',
});
